export default __webpack_public_path__ + "static/media/logo-Biored-red.13162c88.png";